export default "__VITE_ASSET__966e3ff3__"